module.exports = __webpack_public_path__ + "img/logo.2df5c84d.svg";